(function(){
  function wireReviewerReadMoreIn(root){
    // Prepare wraps (idempotent)
    root.querySelectorAll('.before-after-reviewer-description-wrap').forEach(wrap => {
      const nextEl = wrap.querySelector('.before-after-reviewer-description-next');
      const baseEl = wrap.querySelector('.before-after-reviewer-description');
      if (!nextEl) return;
      nextEl.style.overflow = 'hidden';
      nextEl.style.height = nextEl.style.height || '0px';
      nextEl.style.opacity = nextEl.style.opacity || '0';
      if (!nextEl.style.transition) {
        nextEl.style.transition = 'height 0.3s ease, opacity 0.3s ease';
      }
      if (baseEl && !baseEl.dataset.baseText) {
        const original = (baseEl.textContent || '').trimEnd();
        const stripped = original.replace(/\s*(\u2026|\.{3})\s*$/,'');
        baseEl.dataset.baseText = stripped;
      }
    });
    // Delegate click binding once per section root
    if (!root.__reviewerDelegatedBound) {
      root.addEventListener('click', function(e){
        const btn = e.target && e.target.closest('.before-after-reviewer-description-button');
        if (!btn || !root.contains(btn)) return;
        e.preventDefault();
        const wrap = btn.closest('.before-after-reviewer-description-wrap');
        if (!wrap) return;
        const nextEl = wrap.querySelector('.before-after-reviewer-description-next');
        const baseEl = wrap.querySelector('.before-after-reviewer-description');
        if (!nextEl) return;
        const isOpen = wrap.classList.toggle('is-open');
        if (isOpen) {
          if (baseEl && baseEl.dataset.baseText) {
            baseEl.textContent = baseEl.dataset.baseText;
          }
          nextEl.style.height = nextEl.scrollHeight + 'px';
          nextEl.style.opacity = '1';
          btn.setAttribute('aria-expanded', 'true');
          const onEnd = (ev) => {
            if (ev.propertyName === 'height') {
              nextEl.style.height = 'auto';
              nextEl.removeEventListener('transitionend', onEnd);
            }
          };
          nextEl.addEventListener('transitionend', onEnd);
        } else {
          if (baseEl && baseEl.dataset.baseText) {
            baseEl.textContent = baseEl.dataset.baseText + '...';
          }
          if (nextEl.style.height === 'auto') {
            nextEl.style.height = nextEl.scrollHeight + 'px';
            void nextEl.offsetHeight;
          }
          nextEl.style.height = '0px';
          nextEl.style.opacity = '0';
          btn.setAttribute('aria-expanded', 'false');
        }
      });
      Object.defineProperty(root, '__reviewerDelegatedBound', { value: true, enumerable: false, configurable: false });
    }
  }
  function wireReviewerImageModalIn(root){
    // Create singleton modal for the page (shared across sections)
    let modal = document.querySelector('.before-after-reviewer-modal');
    if (!modal) {
      modal = document.createElement('div');
      modal.className = 'before-after-reviewer-modal';
      modal.style.position = 'fixed';
      modal.style.inset = '0';
      modal.style.zIndex = '9999';
      modal.style.background = 'rgba(0,0,0,0.7)';
      modal.style.display = 'none';
      modal.style.alignItems = 'center';
      modal.style.justifyContent = 'center';
      modal.style.padding = '20px';
      modal.style.cursor = 'zoom-out';
      modal.style.boxSizing = 'border-box';
      // Inner wrapper to position close button relative to the image
      const inner = document.createElement('div');
      inner.className = 'before-after-reviewer-modal-inner';
      inner.style.position = 'relative';
      inner.style.display = 'inline-block';
      modal.appendChild(inner);
      // Enlarged image
      const img = document.createElement('img');
      img.className = 'before-after-reviewer-modal-image';
      img.style.maxWidth = '90vw';
      img.style.maxHeight = '90vh';
      img.style.width = 'auto';
      img.style.height = 'auto';
      img.style.boxShadow = '0 8px 30px rgba(0,0,0,0.5)';
      img.style.borderRadius = '8px';
      img.alt = '';
      inner.appendChild(img);
      // Close button (top-right of image)
      const closeBtn = document.createElement('button');
      closeBtn.className = 'before-after-reviewer-modal-close';
      closeBtn.type = 'button';
      closeBtn.setAttribute('aria-label', 'Close');
      closeBtn.style.position = 'absolute';
      closeBtn.style.top = '8px';
      closeBtn.style.right = '8px';
      closeBtn.style.border = 'none';
      closeBtn.style.background = 'transparent';
      closeBtn.style.padding = '6px';
      closeBtn.style.margin = '0';
      closeBtn.style.cursor = 'pointer';
      closeBtn.style.lineHeight = '0';
      closeBtn.style.zIndex = '10001';
      const closeImg = document.createElement('img');
      closeImg.src = 'https://cdn.shopify.com/s/files/1/0928/3882/2261/files/black_cross.webp?v=1765206704';
      closeImg.alt = 'Close';
      closeImg.style.width = '24px';
      closeImg.style.height = '24px';
      closeImg.style.display = 'block';
      closeBtn.appendChild(closeImg);
      inner.appendChild(closeBtn);
      document.body.appendChild(modal);
      // Close handlers
      modal.addEventListener('click', (e) => {
        // Close when clicking outside the image
        if (e.target === modal) {
          modal.style.display = 'none';
          const mimg = modal.querySelector('img.before-after-reviewer-modal-image');
          if (mimg) { mimg.src = ''; mimg.alt = ''; }
        }
      });
      closeBtn.addEventListener('click', (e) => {
        try { e.preventDefault(); e.stopPropagation(); } catch(_) {}
        modal.style.display = 'none';
        const mimg = modal.querySelector('img.before-after-reviewer-modal-image');
        if (mimg) { mimg.src = ''; mimg.alt = ''; }
      });
      // Escape to close
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && modal.style.display !== 'none') {
          modal.style.display = 'none';
          const mimg = modal.querySelector('img.before-after-reviewer-modal-image');
          if (mimg) { mimg.src = ''; mimg.alt = ''; }
        }
      });
    }
    // Delegate clicks within this root
    if (!root.__reviewerImageModalBound) {
      root.addEventListener('click', function(e){
        const wrap = e.target && e.target.closest && e.target.closest('.before-after-reviewer-image-wrap');
        if (!wrap || !root.contains(wrap)) return;
        e.preventDefault();
        const img = wrap.querySelector('img');
        if (!img) return;
        const src = img.currentSrc || img.src;
        if (!src) return;
        const modalImg = document.querySelector('.before-after-reviewer-modal img.before-after-reviewer-modal-image');
        if (!modalImg) return;
        modalImg.src = src;
        modalImg.alt = img.alt || '';
        const m = document.querySelector('.before-after-reviewer-modal');
        if (m) {
          m.style.display = 'flex';
        }
      });
      Object.defineProperty(root, '__reviewerImageModalBound', { value: true, enumerable: false, configurable: false });
    }
  }
  function bootUIAll(){
    const root = document;
    wireReviewerReadMoreIn(root);
    wireReviewerImageModalIn(root);
  }
  if (document.readyState !== 'loading') { bootUIAll(); } else { document.addEventListener('DOMContentLoaded', bootUIAll); }
  document.addEventListener('shopify:section:load', (e) => {
    const root = document;
    wireReviewerReadMoreIn(root);
    wireReviewerImageModalIn(root);
  });
})();
